import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/acompanhamento'
const APICore = process.env.APIBaseURLCore

const GetAllAcompanhamento = (filters = {}, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, filters, config)
const GetExcel = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, filters, config)

const ReportAcompanhamentoRepository = {
  GetAllAcompanhamento,
  GetExcel
}

export default ReportAcompanhamentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/acompanhamento/report.js